export default function AboutSection() {
  return (
    <section id="about" className="bg-white py-24 md:py-32 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 lg:gap-24 items-center">

          {/* RIGHT — premium image with layered cards */}
          <div className="relative order-1 lg:order-2">
            <div className="relative h-[500px] md:h-[620px] rounded-[28px] overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/ddd1749ff9ac606ee93a30874a5ed701.jpg"
                alt="Modern personalized orthodontic care at Smile By Dr. K Chatsworth"
                className="w-full h-full object-cover object-center"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#1C3528]/35 via-transparent to-transparent" />
            </div>

            {/* Gold accent bar */}
            <div className="absolute top-10 -left-3 w-1.5 h-32 bg-gradient-to-b from-[#C4A96E] to-[#C4A96E]/20 rounded-full" />

            {/* Quote card */}
            <div className="absolute bottom-10 -left-5 md:-left-10 bg-white rounded-2xl px-6 py-5 max-w-[270px] border border-[#EAF0EC]">
              <i className="ri-double-quotes-l text-[#C4A96E] text-xl mb-2.5 block" />
              <p
                className="text-[#1A2118] leading-relaxed font-light italic"
                style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '17px' }}
              >
                Every smile deserves the precision and care it was built for.
              </p>
              <div className="flex items-center gap-2.5 mt-4">
                <div className="w-5 h-px bg-[#C4A96E]" />
                <p
                  className="text-[#4C8265] text-[10px] tracking-[0.18em] uppercase font-semibold"
                  style={{ fontFamily: 'DM Sans, sans-serif' }}
                >
                  Dr. K, Orthodontist
                </p>
              </div>
            </div>

            {/* Stats badge */}
            <div className="absolute top-10 right-5 bg-[#1C3528] rounded-2xl px-5 py-4 text-center">
              <p
                className="text-white font-semibold leading-none mb-1"
                style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '28px' }}
              >
                All Ages
              </p>
              <p
                className="text-[#C4A96E] text-[9px] tracking-[0.2em] uppercase font-semibold"
                style={{ fontFamily: 'DM Sans, sans-serif' }}
              >
                Welcome
              </p>
            </div>
          </div>

          {/* LEFT — content */}
          <div className="flex flex-col order-2 lg:order-1">
            <div className="flex items-center gap-3 mb-7">
              <span className="w-8 h-px bg-[#C4A96E]" />
              <span
                className="text-[#C4A96E] text-[10px] tracking-[0.32em] uppercase font-semibold"
                style={{ fontFamily: 'DM Sans, sans-serif' }}
              >
                Welcome to Smile By Dr. K
              </span>
            </div>

            <h2
              className="text-[42px] md:text-[56px] text-[#1A2118] font-semibold leading-[1.06] mb-7"
              style={{ fontFamily: 'Cormorant Garamond, serif', letterSpacing: '-0.015em' }}
            >
              Orthodontic Care<br />
              <span className="font-light italic text-[#4C8265]">Built Around You</span>
            </h2>

            <p
              className="text-[#5A7060] text-base leading-[1.9] mb-5"
              style={{ fontFamily: 'DM Sans, sans-serif' }}
            >
              At Smile By Dr. K, we bring together advanced orthodontic technology and deeply personalized care — because every smile is one of a kind.
            </p>

            <p
              className="text-[#5A7060] text-base leading-[1.9] mb-10"
              style={{ fontFamily: 'DM Sans, sans-serif' }}
            >
              Whether you&rsquo;re a child beginning their orthodontic journey, a teen looking for discreet options, or an adult ready for a transformation — our Chatsworth practice is built to guide you with precision, comfort, and lasting results.
            </p>

            {/* Feature highlights */}
            <div className="grid grid-cols-2 gap-x-6 gap-y-4 mb-11">
              {[
                { icon: 'ri-award-line', text: 'Phase I & II Orthodontics' },
                { icon: 'ri-scan-2-line', text: 'Digital Imaging & Planning' },
                { icon: 'ri-shield-star-line', text: 'InBrace Discreet Options' },
                { icon: 'ri-video-line', text: 'Virtual Consultations' },
              ].map((f) => (
                <div key={f.text} className="flex items-center gap-3">
                  <div className="w-8 h-8 flex items-center justify-center bg-[#F0F6F2] rounded-xl flex-shrink-0">
                    <i className={`${f.icon} text-[#4C8265] text-sm`} />
                  </div>
                  <span
                    className="text-[#2A3D2E] text-sm font-medium leading-snug"
                    style={{ fontFamily: 'DM Sans, sans-serif' }}
                  >
                    {f.text}
                  </span>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href="https://smilebydrkortez.com/request-appointment"
                target="_blank"
                rel="noopener nofollow"
                className="bg-[#1C3528] hover:bg-[#254535] text-white font-medium text-sm px-8 py-4 rounded-full whitespace-nowrap cursor-pointer transition-colors duration-200 flex items-center gap-2.5 justify-center"
                style={{ fontFamily: 'DM Sans, sans-serif' }}
              >
                Schedule a Consultation
                <i className="ri-arrow-right-line" />
              </a>
              <a
                href="https://smilebydrkortez.com/virtual-consult"
                target="_blank"
                rel="noopener nofollow"
                className="border border-[#1C3528]/20 hover:border-[#1C3528]/50 text-[#1C3528] font-medium text-sm px-8 py-4 rounded-full whitespace-nowrap cursor-pointer transition-colors duration-200 flex items-center gap-2.5 justify-center"
                style={{ fontFamily: 'DM Sans, sans-serif' }}
              >
                <i className="ri-video-line text-[#4C8265]" />
                Virtual Consult
              </a>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
